import React from "react";

import Modal from 'react-bootstrap/Modal'

class ModalForm extends React.Component {


  render(){



    return(
      <Modal 

        show={this.props.isOpen} 
        onHide={this.props.closeModal}
        size={this.props.size}


      >
      <Modal.Header closeButton>
        <Modal.Title>{this.props.title}</Modal.Title>

      </Modal.Header>

      <Modal.Body>
      {this.props.hoste}


      </Modal.Body>

    </Modal>
    )
  }
}



export default ModalForm;